<template>
  <div class="qes-file-container">
    <FriedCard v-for="file of files" :key="file.id" :class="['qes-file-item', { compact }]">
      <FriedIcon icon="upload" />
      <FriedH4>{{ fileName(file) }}</FriedH4>
      <FriedIconButton
        v-if="isEditable"
        data-external="qes-file-delete-button"
        @click="$emit('delete', file.id)"
      >
        <FriedIcon icon="delete-bin" />
      </FriedIconButton>
      <FriedButton
        v-else
        button-type="tertiary"
        data-external="qes-file-download-button"
        @click="$emit('download', file.id)"
      >
        {{ t('download') }}
      </FriedButton>
    </FriedCard>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type { DocumentQesFile } from '../types/document-qes-file';

const {
  files,
  isEditable = false,
  compact = false,
} = defineProps<{ files: DocumentQesFile[]; isEditable?: boolean; compact?: boolean }>();

defineEmits<{ delete: [string]; download: [string] }>();

const { t } = useI18n();
const fileName = (file: DocumentQesFile) =>
  `${file.name || file.id}.${file.fileType.toLowerCase()}`;
</script>

<style lang="scss" scoped>
.qes-file {
  &-container {
    margin: var(--spacing-200) 0;
  }

  &-item {
    padding: var(--spacing-200);
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: var(--spacing-50);

    &.compact {
      padding: var(--spacing-50) var(--spacing-100);
    }
  }
}
</style>
